var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list',{attrs:{"id":"ContainerImageSecretList","type":"container_image","get-params":_vm.getParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }